import { Tab, Tabs } from "@mui/material"
import { House, Close } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { changeTab, closeTab } from "../../state/slices/tabsSlice";
import { faHouse, faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { styled } from "@mui/material/styles";
import "./style.css";
import { TabsUnstyled, TabUnstyled, tabUnstyledClasses } from "@mui/base";
import { useEffect } from "react";

const CustomTabs = styled(Tabs)(({ theme }) => ({
    '& .MuiTabs-indicator': {
        background: 'transparent',
    }
}));

const CustomTab = styled(Tab)(({ theme }) => ({
    '&.MuiButtonBase-root.MuiTab-root': {
        background: '#474747',
        marginTop: "5px",
        marginRight: "10px",
        borderRadius: "10px",
        padding: "2px 20px",
        color: "white",
        textTransform: 'none',
        fontWeight: '400',
        fontSize: '11px',
        '&.Mui-disabled': {
            background: '#373737',
            color: '#515151'
        },
        '&.Mui-selected': {
            background: '#6d6d6d'
        },

        '&.MuiButtonBase-root': {
            padding: '7px 20px',
            minHeight: "25px",
            minWidth: "60px",

            '&.MuiSvgIcon-root': {
                fontSize: '7px',
            }
        }
    },
}));


const GDTab = ({ value, disabled, selected, ...rest}) => {
    const dispatch = useDispatch();

    const onClickFecharAba = (e) => {
        dispatch(closeTab(value))
    }

    return (
        // <div className="tab" aria-disabled={disabled} style={{ background: selected ? "#6d6d6d" : "#474747"}}>
            <CustomTab 
                value={value} 
                disabled={disabled} 
                selected={selected} 
                {...rest} 
                icon={<Close onClick={onClickFecharAba} style={{ fontSize: "12px" }} />}
                iconPosition="end"
            />
            // <FontAwesomeIcon icon={faClose} onClick={onClickFecharAba} className="closebutton" />
        // </div>
    )
}

const Abas = () => {
    const {tabs} = useSelector(state => state.tabs);
    const tabsIndex = useSelector(state => state.tabs.tabsIndex)
    const user = useSelector(state => state.user);
    const dispatch = useDispatch();

    const handleChange = (event, newValue) => {
        dispatch(changeTab(newValue))
    }

    return (
        <div>
            <CustomTabs value={tabsIndex} onChange={handleChange} aria-label="abas">
                { tabs && tabs.map((tab) => 
                    tab.Nome === "Home" ? (
                    <CustomTab icon={
                        <FontAwesomeIcon icon={faHouse} style={{fontSize: "18px"}} />} 
                        sx={{color: "white", borderRadius: "10px"}} 
                        key={tab.Codigo}
                        value={tab.Codigo}
                        disabled={user.situacao === 1 || user.situacao === 2}
                    />
                    ) : (
                    <GDTab 
                        key={tab.Codigo} 
                        label={tab.Nome} 
                        value={tab.Codigo} 
                        disabled={user.situacao === 1 || user.situacao === 2}
                     />
                )) }
            </CustomTabs>
        </div>
    )
}

export { Abas }